import React from "react";
import { ClassesLogo, PtLogo } from "../components/logos";
import { ServicesLogo } from "../components/sidebar/servicesIcon";
import { useSelector } from "react-redux";
import { store } from "../redux/storeConfig/store";

export const getNavigationConfig = (gym) => {
  const gymConfig = gym?.configData?.config?.features || {};
 const savedOrder =gym?.settings?.general?.sideBarOrder || [];
//  console.log({savedOrder})

  let navigationConfig = [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      code: [
        "S-SHW-DASH-3D",
        "S-SHW-DASH-1M",
        "S-SHW-DASH-1W",
        "S-SHW-DASH-O",
        "S-LIV-DASH",
      ],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Admin-account"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Admin-Dashboard"
              transform="translate(-32.000000, -351.000000)"
            >
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g
                  id="Dashboard-(Software-Tab)"
                  transform="translate(0.000000, 248.000000)"
                >
                  <g
                    id="dashboard-24px"
                    transform="translate(32.000000, 33.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M4,13 L10,13 C10.55,13 11,12.55 11,12 L11,4 C11,3.45 10.55,3 10,3 L4,3 C3.45,3 3,3.45 3,4 L3,12 C3,12.55 3.45,13 4,13 Z M4,21 L10,21 C10.55,21 11,20.55 11,20 L11,16 C11,15.45 10.55,15 10,15 L4,15 C3.45,15 3,15.45 3,16 L3,20 C3,20.55 3.45,21 4,21 Z M14,21 L20,21 C20.55,21 21,20.55 21,20 L21,12 C21,11.45 20.55,11 20,11 L14,11 C13.45,11 13,11.45 13,12 L13,20 C13,20.55 13.45,21 14,21 Z M13,4 L13,8 C13,8.55 13.45,9 14,9 L20,9 C20.55,9 21,8.55 21,8 L21,4 C21,3.45 20.55,3 20,3 L14,3 C13.45,3 13,3.45 13,4 Z"
                      id="Shape"
                      fill="#8700A9"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/dashboard",
      show: gymConfig?.dashboards?.enabled,
      order:1
    },
    {
      id: "courts",
      title: "Courts",
      type: "item",
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill="#000000"
              d="M120.8 55L87.58 199h18.52l29.1-126h18.2l-20.6 126h18.3l10.1-62H247v62h18v-62h85.8l10.1 62h18.3L358.6 73h18.2l29.1 126h18.5L391.2 55H120.8zm50.9 18h168.6l7.6 46H164.1l7.6-46zM73 217v30h366v-30H73zm-.64 48L20.69 489H491.3l-51.7-224h-18.5l47.6 206h-45L390 265h-18.3l14.2 87H265v-87h-18v87H126.1l14.2-87H122L88.35 471H43.31l47.56-206H72.36zm50.74 105h265.8l16.5 101H106.6l16.5-101z"
            ></path>
          </g>
        </svg>
      ),
      permissions: ["admin", "editor"],
      navLink: "/gym-panel/courtslist",
      show: true,
    },
    {
      id: "members",
      title: "Members",
      type: "item",
      code: [
        "S-MVH-V",
        "S-MAC-P-V",
        "S-M-ADD",
        "S-M-MNG",
        "EXT-END-S",
        "S-EXP",
        "S-IMP",
        "S-VOI-SA",
        "S-RET-SA",
        "ED-SA",
        "S-F/U",
      ],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -515.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Users" transform="translate(0.000000, 434.000000)">
                  <g
                    id="assignment_ind-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.22,2.75 12.41,2.85 12.55,3 C12.67,3.13 12.75,3.31 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.31 11.33,3.13 11.45,3 C11.59,2.85 11.78,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z M12,6 C10.35,6 9,7.35 9,9 C9,10.65 10.35,12 12,12 C13.65,12 15,10.65 15,9 C15,7.35 13.65,6 12,6 Z M12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 Z M6,16.47 L6,18 L18,18 L18,16.47 C18,13.97 14.03,12.89 12,12.89 C9.97,12.89 6,13.96 6,16.47 Z M8.31,16 C9,15.44 10.69,14.88 12,14.88 C13.31,14.88 15.01,15.44 15.69,16 L8.31,16 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/memberslist",
      show: gymConfig?.manageMembers?.enabled,
    },
    {
      id: "services",
      title: "Services & Products",
      code: [
        "S-SERV-PROD",
        "S-CD-E",
        "S-AP-E",
        "S-C/C-OV",
        "S-ADD-PRO",
        "S-PUR-PRO",
        "S-TRA-PRO",
        "S-EDT-PRO",
        "S-DEA-PRO",
        "S-ACC/REJ-PRO",
        "S-RET-V-PRO",
        "S-RET-ClO",
      ],
      type: "item",
      navLink: "/gym-panel/services",
      icon: (
        <ServicesLogo
          color="#64748B"
          classNames={
            "d-inline-flex align-items-center justify-content-center ml-1"
          }
        />
      ),
      show: gymConfig?.retail?.enabled || (gymConfig?.manageMemberships?.enabled && (gymConfig?.manageMemberships?.classMemberships?.enabled || gymConfig?.manageMemberships?.appointmentMemberships?.enabled||gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled)),
    },
    {
      id: "bookings",
      title: "Bookings",
      type: "collapse",
      code: ["S-CCB", "S-CAPP", "S-B-ADD"],
      isPages: true,
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -677.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g
                  id="Appointments"
                  transform="translate(0.000000, 596.000000)"
                >
                  <g
                    id="event-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M16,13 L13,13 C12.45,13 12,13.45 12,14 L12,17 C12,17.55 12.45,18 13,18 L16,18 C16.55,18 17,17.55 17,17 L17,14 C17,13.45 16.55,13 16,13 Z M16,3 L16,4 L8,4 L8,3 C8,2.45 7.55,2 7,2 C6.45,2 6,2.45 6,3 L6,4 L5,4 C3.89,4 3.01,4.9 3.01,6 L3,20 C3,21.1 3.89,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L18,4 L18,3 C18,2.45 17.55,2 17,2 C16.45,2 16,2.45 16,3 Z M18,20 L6,20 C5.45,20 5,19.55 5,19 L5,9 L19,9 L19,19 C19,19.55 18.55,20 18,20 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      dropdownMenu: [
        {
          id: "appointment",
          name: "Appointments",
          navLink: "/gym-panel/bookings/appointments",
          icon: <PtLogo color={"#999999"} />,
          show: gymConfig?.manageMemberships?.enabled && gymConfig?.manageMemberships?.appointmentMemberships?.enabled,
        },
        {
          id: "class",
          name: "Classes/Workshops",
          navLink: "/gym-panel/bookings/classes",
          icon: <ClassesLogo color={"#999999"} />,
          show: gymConfig?.manageMemberships?.enabled && (gymConfig?.manageMemberships?.classMemberships?.enabled||gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled),
        },
        {
          id: "courtBooking",
          name: "Courts",
          navLink: "/gym-panel/bookings/courts",
          icon: <ClassesLogo color={"#999999"} />,
          show: true,
        },
      ],
      show: gymConfig?.manageMemberships?.enabled && (gymConfig?.manageMemberships?.classMemberships?.enabled || gymConfig?.manageMemberships?.appointmentMemberships?.enabled||gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled),
    },
    {
      id: "checkIn",
      title: "Check In",
      code: ["S-M-CH-IN"],
      type: "item",
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Billing" transform="translate(-32.000000, -823.000000)">
              <g id="Appointments" transform="translate(0.000000, 812.000000)">
                <g id="alarm-24px" transform="translate(32.000000, 11.000000)">
                  <g id="Group">
                    <rect
                      id="Rectangle"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    ></rect>
                    <rect
                      id="Rectangle"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    ></rect>
                  </g>
                  <path
                    d="M12,4 C7.03,4 3,8.03 3,13 C3,17.97 7.03,22 12,22 C16.97,22 21,17.97 21,13 C21,8.03 16.97,4 12,4 Z M15.5,16.5 C15.11,16.89 14.48,16.89 14.09,16.5 L11.3,13.71 C11.11,13.52 11,13.27 11,13 L11,9 C11,8.45 11.45,8 12,8 L12,8 C12.55,8 13,8.45 13,9 L13,12.59 L15.5,15.09 C15.89,15.48 15.89,16.11 15.5,16.5 Z M4.88,3.05 L2.05,5.88 C1.66,6.27 1.66,6.9 2.05,7.29 L2.05,7.29 C2.44,7.68 3.07,7.68 3.46,7.29 L6.29,4.46 C6.68,4.07 6.68,3.44 6.29,3.05 L6.29,3.05 C5.9,2.66 5.27,2.66 4.88,3.05 Z M17.71,3.05 L17.71,3.05 C17.32,3.44 17.32,4.07 17.71,4.46 L20.54,7.29 C20.93,7.68 21.56,7.68 21.95,7.29 L21.95,7.29 C22.34,6.9 22.34,6.27 21.95,5.88 L19.12,3.05 C18.73,2.66 18.1,2.66 17.71,3.05 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/check-in",
      show: gymConfig?.reports?.enabled && gymConfig?.reports?.checkInReport?.enabled,
    },
    {
      id: "instructors",
      title: "Instructors",
      type: "item",
      code: ["S-I-ADD", "S-I-EDIT","VIW-INS-LIS"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Admin-account"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g
              id="Admin-Dashboard"
              transform="translate(-32.000000, -648.000000)"
            >
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Trainers" transform="translate(0.000000, 567.000000)">
                  <g
                    id="self_improvement-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <g id="Group">
                      <rect
                        id="Rectangle"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      ></rect>
                      <rect
                        id="Rectangle"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      ></rect>
                    </g>
                    <g
                      id="Group"
                      transform="translate(3.000000, 4.000000)"
                      fill="#000000"
                      fill-rule="nonzero"
                    >
                      <circle id="Oval" cx="9" cy="2" r="2"></circle>
                      <path
                        d="M18,10.94 L18,10.94 C18,10.44 17.64,10.01 17.15,9.96 C15.27,9.75 13.66,8.83 12.4,7.33 L11.06,5.73 C10.68,5.26 10.12,5 9.53,5 L8.48,5 C7.89,5 7.33,5.26 6.95,5.72 L5.61,7.32 C4.36,8.82 2.74,9.74 0.86,9.95 C0.36,10.01 0,10.44 0,10.94 L0,10.94 C0,11.54 0.53,12.01 1.13,11.94 C3.43,11.67 5.45,10.55 7,8.75 L7,11 L3.24,12.5 C2.59,12.76 2.08,13.33 2.01,14.03 C1.91,15.1 2.74,16 3.79,16 L6,16 L6,15.5 C6,14.12 7.12,13 8.5,13 L11.5,13 C11.78,13 12,13.22 12,13.5 C12,13.78 11.78,14 11.5,14 L8.5,14 C7.67,14 7,14.67 7,15.5 L7,16 L14.1,16 C14.95,16 15.75,15.46 15.95,14.63 C16.16,13.74 15.68,12.87 14.87,12.55 L11,11 L11,8.75 C12.56,10.55 14.57,11.66 16.87,11.94 C17.47,12 18,11.54 18,10.94 Z"
                        id="Path"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      permissions: ["admin", "editor"],
      navLink: "/gym-panel/trainerinfolist",
      show: gymConfig?.manageInstructors?.enabled,
    },
    {
      id: "staff",
      title: "Staff",
      type: "item",
      code: ["S-S-MNG","VIW-ST-LIS"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>796B5807-4CEB-49EC-B356-C9F0BFAC9012@1.5x</title>
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="Staff-Page" transform="translate(-32.000000, -569.000000)">
              <g id="Group-15" transform="translate(0.000000, 536.000000)">
                <g id="Gyms" transform="translate(0.000000, 22.000000)">
                  <g
                    id="people_outline_black_24dp"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M9,12 C10.93,12 12.5,10.43 12.5,8.5 C12.5,6.57 10.93,5 9,5 C7.07,5 5.5,6.57 5.5,8.5 C5.5,10.43 7.07,12 9,12 Z M9,7 C9.83,7 10.5,7.67 10.5,8.5 C10.5,9.33 9.83,10 9,10 C8.17,10 7.5,9.33 7.5,8.5 C7.5,7.67 8.17,7 9,7 Z M9,13.75 C6.66,13.75 2,14.92 2,17.25 L2,18 C2,18.55 2.45,19 3,19 L15,19 C15.55,19 16,18.55 16,18 L16,17.25 C16,14.92 11.34,13.75 9,13.75 Z M4.34,17 C5.18,16.42 7.21,15.75 9,15.75 C10.79,15.75 12.82,16.42 13.66,17 L4.34,17 Z M16.04,13.81 C17.2,14.65 18,15.77 18,17.25 L18,19 L21,19 C21.55,19 22,18.55 22,18 L22,17.25 C22,15.23 18.5,14.08 16.04,13.81 Z M15,12 C16.93,12 18.5,10.43 18.5,8.5 C18.5,6.57 16.93,5 15,5 C14.46,5 13.96,5.13 13.5,5.35 C14.13,6.24 14.5,7.33 14.5,8.5 C14.5,9.67 14.13,10.76 13.5,11.65 C13.96,11.87 14.46,12 15,12 Z"
                      id="Shape"
                      fill="#8700A9"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/staffs",
      show: gymConfig?.manageStaff?.enabled,
    },
    {
      id: "packages",
      title: "Packages",
      type: "item",
      code: ["S-PAC-ADD/D", "S-PAC-EDT"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -623.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Packages" transform="translate(0.000000, 542.000000)">
                  <g
                    id="style-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M2.53,19.65 L3.87,20.21 L3.87,11.18 L1.44,17.04 C1.03,18.06 1.52,19.23 2.53,19.65 L2.53,19.65 Z M22.03,15.95 L17.07,3.98 C16.76,3.23 16.03,2.77 15.26,2.75 C15,2.75 14.73,2.79 14.47,2.9 L7.1,5.95 C6.35,6.26 5.89,6.98 5.87,7.75 C5.86,8.02 5.91,8.29 6.02,8.55 L10.98,20.52 C11.29,21.28 12.03,21.74 12.81,21.75 C13.07,21.75 13.33,21.7 13.58,21.6 L20.94,18.55 C21.96,18.13 22.45,16.96 22.03,15.95 L22.03,15.95 Z M12.83,19.75 L7.87,7.79 L15.22,4.75 L15.23,4.75 L20.18,16.7 L12.83,19.75 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                    <circle
                      id="Oval"
                      fill="#000000"
                      fill-rule="nonzero"
                      cx="11"
                      cy="9"
                      r="1"
                    ></circle>
                    <path
                      d="M5.88,19.75 C5.88,20.85 6.78,21.75 7.88,21.75 L9.33,21.75 L5.88,13.41 L5.88,19.75 Z"
                      id="Path"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/packages",
      show: gymConfig?.manageMemberships?.enabled && (gymConfig?.manageMemberships?.gymMemberships?.enabled || gymConfig?.manageMemberships?.classMemberships?.enabled || gymConfig?.manageMemberships?.appointmentMemberships?.enabled),
    },

    {
      id: "financial-party",
      title: "Counterparties",
      type: "item",
      code: ["S-ACP", "A-TCP"],
      icon: (
        <svg
          fill="#000000"
          height="24px"
          width="24px"
          version="1.2"
          baseProfile="tiny"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          // xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 256 256"
          // xml:space="preserve"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              id="XMLID_11_"
              d="M57.9,41.9c11.3,0,20.5-9.2,20.5-20.5c0-11.3-9.2-20.5-20.5-20.5c-11.3,0-20.5,9.2-20.5,20.5 C37.4,32.7,46.6,41.9,57.9,41.9"
            ></path>{" "}
            <path
              id="XMLID_10_"
              d="M203.4,41.6c11.5,0,20.8-9.3,20.8-20.8c0-11.5-9.3-20.8-20.8-20.8c-11.5,0-20.8,9.3-20.8,20.8 C182.6,32.3,191.9,41.6,203.4,41.6"
            ></path>{" "}
            <path
              id="XMLID_7_"
              d="M50.3,158.5c-26.9,0-48.7,21.8-48.7,48.7c0,26.9,21.8,48.8,48.7,48.8c26.9,0,48.8-21.8,48.8-48.8 C99.1,180.3,77.2,158.5,50.3,158.5 M56.1,238.2v7.8H44.4v-7.8c-12.4-1.4-20.4-13.3-20.4-21h12.4c0,3.5,2.7,8.1,8,9.2v-14.6 c-2.7-0.5-4.2-0.9-7.1-1.7c-7.3-2-12.4-8.2-12.4-16.1c0-7.8,7.6-16.6,19.4-18.1v-7.3h11.7v7.3c12.5,1.6,20.1,10.8,20.1,20l-12.2,0 c0-4-3.4-7.7-8-8.1v13.7c3.4,0.7,3.4,0.7,6.5,1.5c11.6,3.2,14.2,10.7,14.2,17.1C76.8,229.8,69,236.5,56.1,238.2"
            ></path>{" "}
            <path
              id="XMLID_4_"
              d="M44.4,199.3c-5.2-0.9-6.6-3.2-6.6-5.6c0-2.8,3.5-5.5,6.6-5.9V199.3z M56.2,226.3V214c5.1,0.7,8.4,3,8.4,6.1 C64.6,222.9,61.6,226.1,56.2,226.3"
            ></path>{" "}
            <path
              id="XMLID_3_"
              d="M31.2,77.4h8.1l-9.3,34.7h56l-9.3-34.7h8.1l9.6,34.7h18L100.6,70c-3.1-10.2-13.2-21-26.4-21H41.5 c-13.2,0-23.3,10.8-26.4,21L3.6,112.1h18L31.2,77.4z"
            ></path>{" "}
            <path
              id="XMLID_2_"
              d="M225.6,48.8c10.2,0,18.5,8.3,18.5,18.5l0,56.8H256v23.3l-24.1,0v96.4c0,6.7-5.5,12.2-12.3,12.2 c-6.7,0-12.2-5.5-12.2-12.2v-96.4h-7.8v96.4c0,6.7-5.5,12.2-12.2,12.2c-6.7,0-12.2-5.5-12.2-12.2v-96.4L1.6,147.4v-23.4h173.6V69.4 l-38.8,46c-8.2,9.4-22.7-2.4-14.5-12.4l40.2-48.4c2.6-2.6,4.9-5.8,14.5-5.8H225.6z"
            ></path>{" "}
          </g>
        </svg>
      ),
      navLink: "/gym-panel/financialParty",
      show: gymConfig?.counterParties?.enabled,
    },
    {
      id: "reports",
      title: "Reports",
      type: "item",
      code: [
        "S-SA-RE",
        "S-ME-RE",
        "S-RT-RE",
        "S-REV-RE",
        "S-ATT-A-RE",
        "S-BO-RE",
        "S-ACC-RE",
        "S-STA-RE",
        "S-VTR",
        "S-AER",
        "S-PAY-RE",
      ],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -623.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Packages" transform="translate(0.000000, 542.000000)">
                  <g
                    id="style-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M2.53,19.65 L3.87,20.21 L3.87,11.18 L1.44,17.04 C1.03,18.06 1.52,19.23 2.53,19.65 L2.53,19.65 Z M22.03,15.95 L17.07,3.98 C16.76,3.23 16.03,2.77 15.26,2.75 C15,2.75 14.73,2.79 14.47,2.9 L7.1,5.95 C6.35,6.26 5.89,6.98 5.87,7.75 C5.86,8.02 5.91,8.29 6.02,8.55 L10.98,20.52 C11.29,21.28 12.03,21.74 12.81,21.75 C13.07,21.75 13.33,21.7 13.58,21.6 L20.94,18.55 C21.96,18.13 22.45,16.96 22.03,15.95 L22.03,15.95 Z M12.83,19.75 L7.87,7.79 L15.22,4.75 L15.23,4.75 L20.18,16.7 L12.83,19.75 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                    <circle
                      id="Oval"
                      fill="#000000"
                      fill-rule="nonzero"
                      cx="11"
                      cy="9"
                      r="1"
                    ></circle>
                    <path
                      d="M5.88,19.75 C5.88,20.85 6.78,21.75 7.88,21.75 L9.33,21.75 L5.88,13.41 L5.88,19.75 Z"
                      id="Path"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/reports",
      show: gymConfig?.reports?.enabled,
    },
    {
      id: "invoice",
      title: "Billing & Payment",
      type: "collapse",
      isPages: true,
      code: ["S-INV-MNG","S-PAYMENTS-FEAT","VIW-IN-LIS"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Billing" transform="translate(-32.000000, -869.000000)">
              <g id="Appointments" transform="translate(0.000000, 858.000000)">
                <g
                  id="receipt-24px"
                  transform="translate(32.000000, 11.000000)"
                >
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M21,2.21 C20.87,2.21 20.74,2.26 20.65,2.36 L19.86,3.15 C19.66,3.35 19.35,3.35 19.15,3.15 L18.36,2.36 C18.16,2.16 17.85,2.16 17.65,2.36 L16.86,3.15 C16.66,3.35 16.35,3.35 16.15,3.15 L15.36,2.36 C15.16,2.16 14.85,2.16 14.65,2.36 L13.86,3.15 C13.66,3.35 13.35,3.35 13.15,3.15 L12.36,2.36 C12.16,2.16 11.85,2.16 11.65,2.36 L10.86,3.15 C10.66,3.35 10.35,3.35 10.15,3.15 L9.35,2.35 C9.15,2.15 8.84,2.15 8.64,2.35 L7.85,3.15 C7.65,3.35 7.34,3.35 7.14,3.15 L6.35,2.35 C6.15,2.15 5.84,2.15 5.64,2.35 L4.85,3.15 C4.65,3.35 4.34,3.35 4.14,3.15 L3.35,2.35 C3.26,2.26 3.13,2.21 3,2.21 L3,21.8 C3.13,21.8 3.26,21.75 3.35,21.65 L4.14,20.86 C4.34,20.66 4.65,20.66 4.85,20.86 L5.64,21.65 C5.84,21.85 6.15,21.85 6.35,21.65 L7.14,20.86 C7.34,20.66 7.65,20.66 7.85,20.86 L8.64,21.65 C8.84,21.85 9.15,21.85 9.35,21.65 L10.14,20.86 C10.34,20.66 10.65,20.66 10.85,20.86 L11.64,21.65 C11.84,21.85 12.15,21.85 12.35,21.65 L13.14,20.86 C13.34,20.66 13.65,20.66 13.85,20.86 L14.64,21.65 C14.84,21.85 15.15,21.85 15.35,21.65 L16.14,20.86 C16.34,20.66 16.65,20.66 16.85,20.86 L17.64,21.65 C17.84,21.85 18.15,21.85 18.35,21.65 L19.14,20.86 C19.34,20.66 19.65,20.66 19.85,20.86 L20.64,21.65 C20.74,21.75 20.87,21.8 20.99,21.8 L20.99,2.21 L21,2.21 Z M17,17 L7,17 C6.45,17 6,16.55 6,16 C6,15.45 6.45,15 7,15 L17,15 C17.55,15 18,15.45 18,16 C18,16.55 17.55,17 17,17 Z M17,13 L7,13 C6.45,13 6,12.55 6,12 C6,11.45 6.45,11 7,11 L17,11 C17.55,11 18,11.45 18,12 C18,12.55 17.55,13 17,13 Z M17,9 L7,9 C6.45,9 6,8.55 6,8 C6,7.45 6.45,7 7,7 L17,7 C17.55,7 18,7.45 18,8 C18,8.55 17.55,9 17,9 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      dropdownMenu: [
        {
          id: "invoices",
          name: "Invoices",
          navLink: "/gym-panel/billing-payment/invoice",
          show: gymConfig?.invoices?.enabled,
        },
        {
          id: "paymentGateways",
          name: "Payment Gateways ",
          navLink: "/gym-panel/billing-payment/payment-gateways",
          show: gymConfig?.onlinePayment?.enabled,
        },
        {
          id: "invoiceProviders",
          name: "Invoice Providers ",
          navLink: "/gym-panel/billing-payment/invoice-providers",
          show:gymConfig?.invoices?.enabled &&gymConfig?.invoicesIntegration?.enabled,
        },
      ],
      show: gymConfig?.invoices?.enabled || gymConfig?.onlinePayment?.enabled,
    },
    {
      id: "payroll",
      title: "Payroll",
      code: ["M-PAY-ROL"],
      isPages:true,
      type: "collapse",
      icon: (
        <svg
          fill="#000000"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          width="24px"
          height="24px"
          viewBox="0 0 256 240"
          enable-background="new 0 0 256 240"
        >
          <path
            d="M84.635,20.256c18.383,0,33.286,14.903,33.286,33.286s-14.903,33.286-33.286,33.286S51.349,71.925,51.349,53.542
          S66.251,20.256,84.635,20.256z M31.002,145.011c0-2.499,1.606-4.194,4.194-4.194s4.194,1.606,4.194,4.194v92.986h91.469v-92.986
          c0-2.499,1.606-4.194,4.194-4.194c2.499,0,4.194,1.606,4.194,4.194v92.986h29.092V136.623c0-22.934-18.74-41.585-41.585-41.585
          h-8.388l-24.451,38.015l-2.945-28.467l4.016-9.638H76.96l4.016,9.638l-3.123,28.645L53.401,95.038h-9.816
          C20.651,95.038,2,113.778,2,136.623v101.375h29.092v-92.986H31.002z M224.674,82.529c-4.562-1.862-6.61-2.793-6.61-4.934
          c0-1.862,1.583-3.445,5.12-3.445c3.445,0,6.051,0.931,7.355,1.583l1.769-6.424c-1.676-0.652-3.631-1.303-6.331-1.583v-5.213h-9.123
          v6.051c-4.562,1.583-7.262,5.213-7.262,9.682c0,5.12,3.724,8.379,9.775,10.52c4.282,1.49,5.865,2.793,5.865,4.934
          c0,2.327-1.955,3.724-5.586,3.724c-3.445,0-6.703-1.21-8.844-2.141l-1.583,6.61c1.583,0.931,4.469,1.676,7.541,1.955v5.12h9.124
          v-5.958c5.12-1.862,7.541-5.586,7.541-10.054C233.798,87.928,230.912,84.763,224.674,82.529z M201.68,34.77h39.473v6.61H201.68
          V34.77z M201.68,21.643h39.473v6.61H201.68V21.643z M254,19.688c-0.186-9.403-7.634-16.851-16.757-17.502
          c-0.279,0-0.745-0.093-1.024-0.093c0,0-58.186-0.093-58.465-0.093c-3.724,0-7.262,1.117-10.054,3.072
          c-2.421,1.676-4.469,3.91-5.772,6.61c-1.303,2.421-2.048,5.213-2.048,8.193c0,0.093,0,0.186,0,0.279c0,0.093,0,0.093,0,0.186
          c0,9.775,7.913,17.781,17.781,17.781c4.282,0,8.193-1.583,11.265-4.096v6.237v30.536v6.61v22.995v19.737H254V21.643
          C254,20.992,254,20.247,254,19.688z M247.483,21.643v12.103v79.784h-52.041c0,0,0.093-93.097,0.093-93.562
          c0-4.189-1.583-8.193-4.096-11.265h45.059c6.237,1.117,10.892,6.517,10.892,12.94H247.483z M201.68,47.897h39.473v6.61H201.68
          V47.897z"
          />
        </svg>
      ),
      dropdownMenu: [
      {
        id: "definePayRates",
        name: "Define Pay Rates",
        navLink: "/gym-panel/payroll/define-payrates",
        show: gymConfig?.payroll?.enabled,
      },
      {
        id: "managePayroll",
        name: "Run / Lock Payroll",
        navLink: "/gym-panel/payroll/manage",
        show: gymConfig?.payroll?.enabled,
      }
      ],
      // navLink: "/gym-panel/payroll",
      show: gymConfig?.payroll?.enabled,
    },
    // {
    //   id: "subscribedUsers",
    //   title: "Subscribed Users",
    //   type: "item",
    //   icon: (
    //     <svg
    //       width="24px"
    //       height="24px"
    //       viewBox="0 0 24 24"
    //       version="1.1"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <title>87E7C48D-75FC-4E8C-9B53-1687B96A2BD4@1.5x</title>
    //       <g
    //         id="Gym-Admin"
    //         stroke="none"
    //         stroke-width="1"
    //         fill="none"
    //         fill-rule="evenodd"
    //       >
    //         <g
    //           id="Subscribed-users"
    //           transform="translate(-32.000000, -914.000000)"
    //         >
    //           <g id="Dashboard" transform="translate(0.000000, 903.000000)">
    //             <g
    //               id="card_membership-24px"
    //               transform="translate(32.000000, 11.000000)"
    //             >
    //               <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
    //               <path
    //                 d="M20,2 L4,2 C2.89,2 2,2.89 2,4 L2,15 C2,16.11 2.89,17 4,17 L8,17 L8,22 L12,20 L16,22 L16,17 L20,17 C21.11,17 22,16.11 22,15 L22,4 C22,2.89 21.11,2 20,2 Z M20,15 L4,15 L4,13 L20,13 L20,15 Z M20,10 L4,10 L4,4 L20,4 L20,10 Z"
    //                 id="Shape"
    //                 fill="#8700A9"
    //                 fill-rule="nonzero"
    //               ></path>
    //             </g>
    //           </g>
    //         </g>
    //       </g>
    //     </svg>
    //   ),
    //   navLink: "/gym-panel/subscribed-users",
    // },
    {
      id: "followupProgram",
      title: "Follow-up Programs",
      type: "item",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 16 16"><path fill="currentColor" d="M15.5 11a.5.5 0 0 1 .5.5a2.5 2.5 0 0 1-2.336 2.495L13.5 14H9.707l1.147 1.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057l-2-2a.5.5 0 0 1-.057-.638l.057-.07l2-2a.5.5 0 0 1 .765.638l-.057.07L9.707 13H13.5a1.5 1.5 0 0 0 1.5-1.5a.5.5 0 0 1 .5-.5M6 0a6 6 0 0 1 5.917 7H10.9A5 5 0 1 0 7 10.9v1.017A6 6 0 1 1 6 0m7.784 6.089l.07.057l2 2a.5.5 0 0 1 .057.638l-.057.07l-2 2a.5.5 0 0 1-.765-.638l.057-.07L14.293 9H10.5A1.5 1.5 0 0 0 9 10.5a.5.5 0 1 1-1 0a2.5 2.5 0 0 1 2.336-2.495L10.5 8l3.793-.001l-1.147-1.145a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057M6.5 2a.5.5 0 0 1 .492.41L7 2.5v4a.5.5 0 0 1-.41.492L6.5 7h-3a.5.5 0 0 1-.09-.992L3.5 6H6V2.5a.5.5 0 0 1 .41-.492z"/></svg>
      ),
      navLink: "/gym-panel/followup-programs",
      show: gymConfig?.followupProgram?.enabled,
    },
    {
      id: "medicalTemplates",
      title: "Medical Templates",
      type: "collapse",
      isPages: true,
      code: ["S-INV-MNG","S-PAYMENTS-FEAT","VIW-IN-LIS"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Billing" transform="translate(-32.000000, -869.000000)">
              <g id="Appointments" transform="translate(0.000000, 858.000000)">
                <g
                  id="receipt-24px"
                  transform="translate(32.000000, 11.000000)"
                >
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M21,2.21 C20.87,2.21 20.74,2.26 20.65,2.36 L19.86,3.15 C19.66,3.35 19.35,3.35 19.15,3.15 L18.36,2.36 C18.16,2.16 17.85,2.16 17.65,2.36 L16.86,3.15 C16.66,3.35 16.35,3.35 16.15,3.15 L15.36,2.36 C15.16,2.16 14.85,2.16 14.65,2.36 L13.86,3.15 C13.66,3.35 13.35,3.35 13.15,3.15 L12.36,2.36 C12.16,2.16 11.85,2.16 11.65,2.36 L10.86,3.15 C10.66,3.35 10.35,3.35 10.15,3.15 L9.35,2.35 C9.15,2.15 8.84,2.15 8.64,2.35 L7.85,3.15 C7.65,3.35 7.34,3.35 7.14,3.15 L6.35,2.35 C6.15,2.15 5.84,2.15 5.64,2.35 L4.85,3.15 C4.65,3.35 4.34,3.35 4.14,3.15 L3.35,2.35 C3.26,2.26 3.13,2.21 3,2.21 L3,21.8 C3.13,21.8 3.26,21.75 3.35,21.65 L4.14,20.86 C4.34,20.66 4.65,20.66 4.85,20.86 L5.64,21.65 C5.84,21.85 6.15,21.85 6.35,21.65 L7.14,20.86 C7.34,20.66 7.65,20.66 7.85,20.86 L8.64,21.65 C8.84,21.85 9.15,21.85 9.35,21.65 L10.14,20.86 C10.34,20.66 10.65,20.66 10.85,20.86 L11.64,21.65 C11.84,21.85 12.15,21.85 12.35,21.65 L13.14,20.86 C13.34,20.66 13.65,20.66 13.85,20.86 L14.64,21.65 C14.84,21.85 15.15,21.85 15.35,21.65 L16.14,20.86 C16.34,20.66 16.65,20.66 16.85,20.86 L17.64,21.65 C17.84,21.85 18.15,21.85 18.35,21.65 L19.14,20.86 C19.34,20.66 19.65,20.66 19.85,20.86 L20.64,21.65 C20.74,21.75 20.87,21.8 20.99,21.8 L20.99,2.21 L21,2.21 Z M17,17 L7,17 C6.45,17 6,16.55 6,16 C6,15.45 6.45,15 7,15 L17,15 C17.55,15 18,15.45 18,16 C18,16.55 17.55,17 17,17 Z M17,13 L7,13 C6.45,13 6,12.55 6,12 C6,11.45 6.45,11 7,11 L17,11 C17.55,11 18,11.45 18,12 C18,12.55 17.55,13 17,13 Z M17,9 L7,9 C6.45,9 6,8.55 6,8 C6,7.45 6.45,7 7,7 L17,7 C17.55,7 18,7.45 18,8 C18,8.55 17.55,9 17,9 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      dropdownMenu: [
        {
          id: "assessments",
          name: "Assessments",
          navLink: "/gym-panel/templates/assessments",
          show: gymConfig?.medicalTemplate?.enabled,
        },
        {
          id: "treatments",
          name: "Treatments",
          navLink: "/gym-panel/templates/treatments",
          show: gymConfig?.medicalTemplate?.enabled,
        },
      ],
      show: gymConfig?.medicalTemplate?.enabled
    },

    {
      id: "videosLibrary",
      title: "Videos Library",
      type: "item",
      icon: (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8563 9.91563L13.6563 8.03438C13.9188 7.85938 14.0501 7.61875 14.0501 7.3125C14.0501 7.00625 13.9188 6.76563 13.6563 6.59063L10.8563 4.70938C10.5646 4.50521 10.2657 4.49063 9.95943 4.66563C9.65318 4.84063 9.50006 5.10313 9.50006 5.45313V9.17188C9.50006 9.52188 9.65318 9.78438 9.95943 9.95938C10.2657 10.1344 10.5646 10.1198 10.8563 9.91563ZM3.98756 18.1406C3.50631 18.2135 3.07245 18.1005 2.68599 17.8016C2.29954 17.5026 2.07714 17.1125 2.01881 16.6313L0.859432 7.07188C0.801099 6.59063 0.917765 6.16042 1.20943 5.78125C1.5011 5.40208 1.88756 5.18333 2.36881 5.125L3.37506 4.99375V12.125C3.37506 13.0875 3.71777 13.9115 4.40318 14.5969C5.0886 15.2823 5.91256 15.625 6.87506 15.625H15.0126C14.9251 15.975 14.7501 16.2776 14.4876 16.5328C14.2251 16.788 13.9042 16.9375 13.5251 16.9813L3.98756 18.1406ZM6.87506 13.875C6.39381 13.875 5.98183 13.7036 5.63912 13.3609C5.29641 13.0182 5.12506 12.6063 5.12506 12.125V2.5C5.12506 2.01875 5.29641 1.60677 5.63912 1.26406C5.98183 0.921354 6.39381 0.75 6.87506 0.75H16.5001C16.9813 0.75 17.3933 0.921354 17.736 1.26406C18.0787 1.60677 18.2501 2.01875 18.2501 2.5V12.125C18.2501 12.6063 18.0787 13.0182 17.736 13.3609C17.3933 13.7036 16.9813 13.875 16.5001 13.875H6.87506Z" fill="#4D4467"/>
        </svg>
      ),
      navLink: "/gym-panel/videos-library",
      show: gymConfig?.videosLibrary?.enabled,
    },
    {
      id: "wod",
      title: "Workouts",
      code: ["S-W-ADD", "S-W-MADD"],
      type: "item",
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -569.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Users" transform="translate(0.000000, 488.000000)">
                  <g
                    id="Kettlebell"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <rect
                      id="Rectangle"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    ></rect>
                    <path
                      d="M18.6467511,4.05704946 C18.512155,3.80927466 18.3434329,3.58064608 18.1450361,3.37702024 C17.9464273,3.17316915 17.6583705,2.94251333 17.4046515,2.79474945 C14.1701053,1.66985182 9.74941767,1.82009345 6.7535412,2.73866224 C6.50512127,2.88484938 6.03520065,3.1792509 5.84337468,3.38084949 C5.65133675,3.58267333 5.48791375,3.80949991 5.35331763,4.05704946 C4.81535707,5.04747294 4.89463101,6.32982019 5.57121497,7.57522648 L7.22876088,10.6260101 C6.14245362,11.8540721 5.47667974,13.5089826 5.47667974,15.3276497 C5.47667974,18.5629129 7.58400986,21.2753713 10.4194308,22 L13.4498571,22 C16.285702,21.2753713 18.3928201,18.5629129 18.3928201,15.3276497 C18.3928201,13.5544831 17.7601124,11.9360631 16.7210728,10.7181373 L18.4288538,7.57522648 C19.1052258,6.32982019 19.1847117,5.04747294 18.6467511,4.05704946 Z M16.1701243,7.20280683 C15.9922309,7.51858458 15.7845057,7.8869171 15.5620841,8.281527 C15.4311317,8.51375616 15.2951343,8.75496904 15.156724,9 C14.2058386,8.46726541 13.1143495,8.16428945 11.9539842,8.16428945 C10.8350762,8.16428945 9.78087672,8.44615367 8.85433931,8.94385175 C8.72689654,8.71813579 8.60186664,8.49601331 8.48078504,8.28175159 C8.25836342,7.88714169 8.0506383,7.51880918 7.87252552,7.20280683 C7.4840554,6.44952191 6.70207011,5.64907247 7.11905582,4.74149216 C7.32765835,4.36776941 7.99075555,4.26018936 8.42594737,4.22425448 C8.42594737,4.22425448 8.71570966,4.162716 9.43276714,4.11375473 C11.589862,3.96642172 13.6412299,3.91319318 16.0483846,4.26108774 C16.2047817,4.31431628 16.5555235,4.42122254 16.7117012,4.52790422 C17.441481,5.43548452 16.6075096,6.39606878 16.1701243,7.20280683 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/wod",
      show: gymConfig?.workouts?.enabled,
    },
    {
      id: "gate",
      title: "Gates",
      code: "S-GATES-FEAT",
      type: "item",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24px"
          height="24px"
          viewBox="0 0 512 512"
        >
          <path
            fill="#000000"
            d="M99.73 57L25 131.7V487h110V188.3l80-80V57H99.73zM80 103h80v18H80v-18zm138 27.7L154.7 194c6.4 3.2 13.6 5 21.3 5 26.1 0 47-20.9 47-47 0-7.7-1.8-14.9-5-21.3zm22.7 15.3c.2 2 .3 4 .3 6 0 8.5-1.7 16.6-4.6 24H473c5.8 0 8.9-1.8 11.3-4.5 2.3-2.6 3.7-6.5 3.7-10.5s-1.4-7.9-3.7-10.5c-2.4-2.7-5.5-4.5-11.3-4.5H240.7zm-15.2 48c-4 4.8-8.7 8.9-13.9 12.3l216.8 117.9c5 2.7 8.7 2.6 12 1.4 3.4-1.2 6.5-4 8.4-7.5 1.9-3.5 2.5-7.5 1.7-11-.8-3.4-2.7-6.5-7.7-9.3L251.7 194h-26.2zm-35 21.3c-4.2 1-8.5 1.6-12.9 1.7l86.7 211.6c2.2 5.3 5.1 7.5 8.5 8.7 3.3 1.1 7.5.9 11.2-.6 3.7-1.5 6.7-4.2 8.3-7.4 1.5-3.2 2-6.8-.1-12.1l-77.4-188.6-24.3-13.3z"
          />
        </svg>
      ),
      navLink: "/gym-panel/gate",
      show: gymConfig?.gates?.enabled,
    },
    {
      id: "info",
      title: "Info",
      type: "item",
      code: ["S-INF"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>6AB99C0B-0DAC-41B6-B748-720E6DDEBA3A</title>
          <g
            id="Admin-account"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g
              id="Admin-Dashboard"
              transform="translate(-32.000000, -543.000000)"
            >
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g id="Info" transform="translate(0.000000, 462.000000)">
                  <g
                    id="person-24px-(2)"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,19 C4,19.55 4.45,20 5,20 L19,20 C19.55,20 20,19.55 20,19 L20,18 C20,15.34 14.67,14 12,14 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/gyminfo",
      show: true,
    },
    {
      id: "notification",
      title: "Notifications",
      code: ["S-NF", "S-PU-NOT"],
      type: "item",
      icon: (
        <div style={{ position: "relative", display: "inline-block" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 25 32"
          >
            <g>
              <g>
                <path
                  fill="#FF9E00"
                  d="M8.508 27.817v.025a3.745 3.745 0 1 0 7.49 0v-.025z"
                ></path>
              </g>
              <g>
                <path
                  fill="#FF9E00"
                  d="M24.21 23.136l-3.37-4.951v-6.178a8.59 8.59 0 0 0-6.903-8.421V1.684a1.684 1.684 0 0 0-3.368 0v1.902a8.59 8.59 0 0 0-6.903 8.421v6.178l-3.37 4.951a1.703 1.703 0 0 0 1.407 2.66h21.1a1.703 1.703 0 0 0 1.407-2.66z"
                ></path>
              </g>
            </g>
          </svg>

          {/* Badge */}

          <span
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              padding: "0 6px",
              fontSize: "12px",
              lineHeight: "18px",
            }}
          >
            {store?.getState()?.notification?.unreadNotificationCount || 0}
          </span>
        </div>
      ),
      navLink: "/gym-panel/notification",
      show: gymConfig?.adminNotificationsPage?.enabled,
    },
    {
      id: "emails-templates",
      title: "Email Templates",
      type: "item",
      code: ["S-EMT-M"],
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Admin-account"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g
              id="Admin-Dashboard"
              transform="translate(-32.000000, -810.000000)"
            >
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g
                  id="Manage-EMail-Templates"
                  transform="translate(0.000000, 729.000000)"
                >
                  <g
                    id="all_inbox-24px"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <path
                      d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,12 C3,13.1 3.9,14 5,14 L19,14 C20.1,14 21,13.1 21,12 L21,5 C21,3.9 20.1,3 19,3 Z M19,9 L15.86,9 C15.39,9 15.02,9.33 14.89,9.78 C14.53,11.04 13.35,12 12,12 C10.65,12 9.47,11.04 9.11,9.78 C8.98,9.33 8.61,9 8.14,9 L5,9 L5,6 C5,5.45 5.45,5 6,5 L18,5 C18.55,5 19,5.45 19,6 L19,9 Z M15.87,16 L20,16 C20.55,16 21,16.45 21,17 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,17 C3,16.45 3.45,16 4,16 L8.13,16 C8.6,16 8.98,16.34 9.11,16.8 C9.46,18.07 10.62,19 12,19 C13.38,19 14.54,18.07 14.89,16.8 C15.02,16.34 15.4,16 15.87,16 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/emailTemplates",
      show: gymConfig?.manageEmailTemplates?.enabled,
    },

    {
      id: "setting-privacy",
      title: "Settings",
      type: "item",
      icon: (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Gym-Admin"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.5"
          >
            <g id="Gym-Info" transform="translate(-32.000000, -731.000000)">
              <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
                <g
                  id="Appointments"
                  transform="translate(0.000000, 650.000000)"
                >
                  <g
                    id="lock-24px-(1)"
                    transform="translate(32.000000, 11.000000)"
                  >
                    <g id="Group">
                      <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                      <polygon
                        id="Path"
                        opacity="0.87"
                        points="0 0 24 0 24 24 0 24"
                      ></polygon>
                    </g>
                    <path
                      d="M18,8 L17,8 L17,6 C17,3.24 14.76,1 12,1 C9.24,1 7,3.24 7,6 L7,8 L6,8 C4.9,8 4,8.9 4,10 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,10 C20,8.9 19.1,8 18,8 Z M12,17 C10.9,17 10,16.1 10,15 C10,13.9 10.9,13 12,13 C13.1,13 14,13.9 14,15 C14,16.1 13.1,17 12,17 Z M9,8 L9,6 C9,4.34 10.34,3 12,3 C13.66,3 15,4.34 15,6 L15,8 L9,8 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      navLink: "/gym-panel/settings",
      show: true,
    },
    {
      id: "notificationManagement",
      title: "Push Notifications Management",
      code: ["S-NF", "S-PU-NOT"],
      type: "item",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5l-4 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
            stroke="grey"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
            fill="grey"
          />
          <path
            d="M17.5 7.5V6m0 10v-1.5m2.121-7.379 1.06-1.06m-6.363 6.364-1.06 1.06m8.485 0-1.06-1.06m-6.364-6.364-1.06 1.06"
            stroke="grey"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        </svg>

      ),
      navLink: "/gym-panel/push-notification/management",
      show: gymConfig?.adminNotificationsPage?.enabled,
    },
    {
      id: "attachmentLibrary",
      title: "Attachment Library",
      type: "item",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 6.5L8.8 14.2C7.7 15.3 7.7 17 8.8 18.1C9.9 19.2 11.6 19.2 12.7 18.1L20 10.8C21.7 9.1 21.7 6.3 20 4.6C18.3 2.9 15.5 2.9 13.8 4.6L6.3 12.1"
                stroke="#4D4467" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 7H13V21H3V7Z" stroke="#4D4467" strokeWidth="1.5"/>
          <path d="M7 3H17V17H7V3Z" stroke="#4D4467" strokeWidth="1.5"/>
        </svg>

      ),
      navLink: "/gym-panel/attachment-library",
      show: gymConfig?.attachmentLibrary?.enabled,
    },
    {
      id:"leads",
      title:"Leads Management",
      type:"item",
      icon:(
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 17H7C5.89543 17 5 16.1046 5 15V9C5 7.89543 5.89543 7 7 7H17C18.1046 7 19 7.89543 19 9V15C19 16.1046 18.1046 17 17 17Z" stroke="#4D4467" strokeWidth="2"/>
          <path d="M8.5 3H8C6.34315 3 5.22222 3.88889 5.22222 5V6H6L8.5 3Z" stroke="#4D4467" strokeWidth="2"/>
          <path d="M8.5 3L6.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.5 -0.5L-0.333333 -2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-2V-2H-1V+6Z" stroke="#4D4467" strokeWidth="1"/>
        </svg>
      ),
      navLink:"/gym-panel/leads",
      show: gymConfig?.leadsManagement?.enabled,
    },
    {
      id:"scheduledTasks",
      title:"Scheduled Tasks",
      type:"item",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 11L11 13L15 9"
            stroke="#4D4467"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5H19M5 19H19M5 12H6M5 6H6M5 18H6"
            stroke="#4D4467"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      navLink:"/gym-panel/user/followups",
      show: gymConfig?.leadsManagement?.enabled,
    }
    
  ];
  if (savedOrder.length) {
    const orderedItems = savedOrder
      .map(id => navigationConfig.find(item => item.id === id))
      .filter(Boolean);
    const remaining = navigationConfig.filter(i => !savedOrder.includes(i.id));
    navigationConfig = [...orderedItems, ...remaining];
  }
  return navigationConfig;

};
const useNavigationConfig = () => {
  const { gym, gymConfig } = useSelector((state) => state.gym);

  return getNavigationConfig(gym, gymConfig);
};

export default useNavigationConfig;
